import { Outlet } from 'react-router-dom'
import packageJson from '../../package.json'
import Navbar from './Navbar'

const currentDate = new Date().getFullYear()

export default function Layout() {
    return (
        <div className='page-container'>
            <header>
                <Navbar />
            </header>
            <main className='page-content'>
                <Outlet />
            </main>
            <footer className='bg-blue py-3 text-white text-center'>
                DERECHOS RESERVADOS @ {currentDate} v{packageJson.version} | DTIC UMSS
            </footer>
        </div>
    )
}
